import script from "./FileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=2244918f&lang=scss"

const __exports__ = script;

export default __exports__